var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('div',{staticClass:"spinner-overlay"},[_c('div',{staticClass:"spinner-container"},[_c('DualRingLoader',{attrs:{"size":100,"color":_vm.loadercolor}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }